import { useEffect, useState } from 'react'

export function useCyclingLabel(
  labels: string[],
  active: boolean,
  intervalMs = 3000,
): string {
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * Math.max(1, labels.length)),
  )

  useEffect(() => {
    if (!active || labels.length <= 1) return
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % labels.length)
    }, intervalMs)
    return () => clearInterval(id)
  }, [active, labels.length, intervalMs])

  return labels[index] ?? labels[0] ?? ''
}
